import React, { useState } from 'react';
import { Hero } from '../components/Hero';
import { FeatureCards } from '../components/FeatureCards';
import { CasinoSection } from '../components/CasinoSection';
import { RestaurantSection } from '../components/RestaurantSection';
import { HotelSection } from '../components/HotelSection';
import { EnergyHub } from '../components/EnergyHub';
import { TruckLogistics } from '../components/TruckLogistics';
import { LocationStrip } from '../components/LocationStrip';
import { Footer } from '../components/Footer';
import { BookingModal } from '../components/BookingModal';
export function HomePage() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  return <>
      <BookingModal isOpen={isBookingOpen} onClose={() => setIsBookingOpen(false)} data-id="element-410" />
      <Hero onBookHotel={() => setIsBookingOpen(true)} data-id="element-411" />
      <FeatureCards data-id="element-412" />
      <CasinoSection data-id="element-413" />
      <RestaurantSection data-id="element-414" />
      <HotelSection data-id="element-415" />
      <EnergyHub data-id="element-416" />
      <TruckLogistics data-id="element-417" />
      <LocationStrip data-id="element-418" />
      <Footer data-id="element-419" />
    </>;
}